module.exports = __webpack_public_path__ + "static/media/CustomColor.195f39eb.svg";